const getToday = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

const shiftDate = (dateStr, days) => {
  const d = dateStr ? new Date(dateStr + "T00:00:00") : new Date();
  d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

const normalize = (value) => ({
  from: value?.from || "",
  to: value?.to || "",
});

/** Map accent shorthand to Tailwind class pairs [bg, hover-bg]. */
const ACCENT_MAP = {
  blue:   ["bg-blue-600",   "hover:bg-blue-700",   "focus:ring-blue-500"],
  teal:   ["bg-teal-600",   "hover:bg-teal-700",   "focus:ring-teal-500"],
  purple: ["bg-purple-600", "hover:bg-purple-700", "focus:ring-purple-500"],
};

export default function DateFilter({ value, onChange, accent = "blue", showViewAll = true }) {
  const { from, to } = normalize(value);
  const [bg, hoverBg, focusRing] = ACCENT_MAP[accent] || ACCENT_MAP.blue;

  const update = (next) => {
    onChange({
      from: next.from || null,
      to: next.to || null,
    });
  };

  const shiftRange = (days) => {
    const newFrom = shiftDate(from || getToday(), days);
    const newTo = shiftDate(to || getToday(), days);
    onChange({ from: newFrom, to: newTo });
  };

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={() => shiftRange(-1)}
        className={`text-sm text-white ${bg} ${hoverBg} w-8 py-1.5 rounded font-bold text-center`}
        title="Previous day"
      >
        &lt;
      </button>
      <button
        type="button"
        onClick={() => shiftRange(1)}
        className={`text-sm text-white ${bg} ${hoverBg} w-8 py-1.5 rounded font-bold text-center`}
        title="Next day"
      >
        &gt;
      </button>
      <label className="text-sm font-medium text-gray-700">Date from:</label>
      <input
        type="date"
        value={from}
        onChange={(e) => update({ from: e.target.value, to })}
        className={`border rounded px-3 py-1.5 text-sm focus:outline-none focus:ring-2 ${focusRing}`}
      />
      <label className="text-sm font-medium text-gray-700">to:</label>
      <input
        type="date"
        value={to}
        onChange={(e) => update({ from, to: e.target.value })}
        className={`border rounded px-3 py-1.5 text-sm focus:outline-none focus:ring-2 ${focusRing}`}
      />
      <button
        type="button"
        onClick={() => onChange({ from: getToday(), to: getToday() })}
        className={`text-sm text-white ${bg} ${hoverBg} px-3 py-1.5 rounded`}
      >
        Today
      </button>
      {showViewAll && (
        <button
          type="button"
          onClick={() => onChange({ from: null, to: null })}
          className="text-sm text-gray-600 border border-gray-300 hover:bg-gray-100 px-3 py-1.5 rounded"
        >
          View All
        </button>
      )}
    </div>
  );
}
